export default __webpack_public_path__ + "static/media/raiLocate.7f1c99c9.jpg";